import './scss/configurator.scss';
import '../_shared/form_builder_2/scss/index.scss';

import Client from './client/client';

import CarValidator from './helpers/car-validator';
import ConflictResolver from './helpers/conflict-resolver';
import CarDiff from './helpers/car-diff';
import CarManager from './helpers/car-manager';
import DataHelper from './helpers/data-helper';
import HashManager from './helpers/hash-manager';
import CheckoutSession from './helpers/checkout-session';
import EcommNudge from './helpers/ecomm-nudge';
import LinkParams from './helpers/link-params';
import CarPreselect from './helpers/car-preselect'
import FinancePreselect from './helpers/finance-preselect';
import PromotionsHelperAPI from './helpers/promotions-helper-api';
import PromotionsHelperSpreadsheet from './helpers/promotions-helper-spreadsheet';

import Car from './models/car';
import Finance from './models/finance';
import PartEx from './models/part-ex';
import PricingAPI from './models/pricing-api';
import PricingSpreadsheet from './models/pricing-spreadsheet';

import AccessoriesModal from './views/accessories-modal';
import CarOptions from './views/car-options';
import CompareModal from './views/compare-modal';
import ConflictModal from './views/conflict-modal';
import FinanceCalculator from './views/finance-calculator';
import KeyFeaturesModal from './views/key-features-modal';
import ExtrasModal from './views/extras-modal';
import Navigation from './views/navigation';
import PartExchange from './views/part-exchange';
import PriceManager from './views/price-manager';
import Summary from './views/summary';
import Visualiser from './views/visualiser';
import StockChecker from './helpers/stock-checker';
import PreselectModal from './views/preselect-modal';
import LeadTimeAPI from './views/lead-time-api';
import LeadTimeSpreadsheet from './views/lead-time-spreadsheet';
import OrderableHelperAPI from './helpers/orderable-helper-api';
import OrderableHelperSpreadsheet from './helpers/orderable-helper-spreadsheet';
import Loader from './views/loader';
import FinanceCompareModal from './views/finance-compare-modal';
import PromotionsManager from './views/promotions-manager';

export default class Configurator {
    constructor(el) {
        this.el = el;
        this.pricingSource = {
            key: window.HONDA.CarConfigurator.pricingSource,
            isSpreadsheet: window.HONDA.CarConfigurator.pricingSource === 'spreadsheet',
            isAPI: window.HONDA.CarConfigurator.pricingSource === 'api'
                || window.HONDA.CarConfigurator.pricingSource !== 'spreadsheet',
        };
        this.financeProvider = window.HONDA.CarConfigurator.financeProvider;

        this.data = DataHelper.process(window.HONDA.CarConfigurator.data);
        this.client = new Client(this);
        this.hashManager = new HashManager(this);

        this.car = new Car(this);
        this.pricing = this.pricingSource.isSpreadsheet ?
            new PricingSpreadsheet(this) :
            new PricingAPI(this);
        this.finance = new Finance(this);
        this.partEx = new PartEx(this);

        this.validator = new CarValidator(this);
        this.resolver = new ConflictResolver(this);
        this.diff = new CarDiff(this);
        this.carManager = new CarManager(this);
        this.checkoutSession = new CheckoutSession(this);
        this.ecommNudge = new EcommNudge(this);
        this.linkParams = new LinkParams(this);
        this.stockChecker = new StockChecker(this);
        this.orderableHelper = this.pricingSource.isSpreadsheet ? 
            new OrderableHelperSpreadsheet(this) :
            new OrderableHelperAPI(this);
        this.carPreselect = new CarPreselect(this);
        this.financePreselect = new FinancePreselect(this)
        this.promotionsHelper = this.pricingSource.isSpreadsheet ? 
            new PromotionsHelperSpreadsheet(this) :
            new PromotionsHelperAPI(this);
        this.loader = new Loader(this);
        this.navigation = new Navigation(this);
        this.accessoriesModal = new AccessoriesModal(this);
        this.carOptions = new CarOptions(this);
        this.compareModal = new CompareModal(this);
        this.leadTime = this.pricingSource.isSpreadsheet ? 
            new LeadTimeSpreadsheet(this) :
            new LeadTimeAPI(this);
        this.conflictModal = new ConflictModal(this);
        this.preselectModal = new PreselectModal(this);
        this.financeCalculator = new FinanceCalculator(this);
        this.keyFeaturesModal = new KeyFeaturesModal(this);
        this.extrasModal = new ExtrasModal(this);
        this.priceManager = new PriceManager(this);
        this.partExchange = new PartExchange(this);
        this.summary = new Summary(this);
        this.visualiser = new Visualiser(this);
        this.financeCompareModal = new FinanceCompareModal(this);
        this.promotionsManager = new PromotionsManager(this);

        this.init();
    }

    async init() {
        this.loader.show();
        await this.pricing.getMTOPricing();
        this.orderableHelper.init();
        this.carOptions.init();
        this.financePreselect.preselect();
        this.carPreselect.preselect();
        this.partExchange.preselect();
        this.loader.hide();
    }

    showLoaders() {
        this.navigation.showLoader();
        this.financeCalculator.showLoader();
        this.summary.showLoader();
    }

    update = _.debounce(async () => {
        this.showLoaders();

        this.carOptions.update();
        this.visualiser.update();
        this.leadTime.update();

        await Promise.all([
            this.priceManager.update(),
            this.promotionsManager.update(),
        ]);
        if (!this.pricing.hasPricing()) { return; }

        await this.financeCalculator.update();
        await this.summary.update();

        this.navigation.scrollOnLoad();
    }, 100);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.configurator--container').forEach((el) => new Configurator(el));
});
